import { subTitle, valueStyle } from "../utils/style";


function LeaveCard({ key, leave }) {

    return(
        <div className='rounded-xl shadow-lg p-4' key={key}>
            <div className='flex justify-between border-b border-customThree py-2'>
                <div className={subTitle}>{leave.date}</div>
                <div className={'bg-[#BED1E5] text-customOne px-4 py-1 rounded-lg'}>{leave.status}</div>
            </div>
            <div className='grid grid-cols-3 pt-4'>
                <div className={subTitle}>Apply Days</div>
                <div className={subTitle}>Reason</div>
                <div className={subTitle}>Approved By</div>
                <div className={valueStyle}>1 day</div>
                <div className={valueStyle}>{leave.reason}</div>
                <div className={valueStyle}>{leave.approver || ''}</div>
            </div>
        </div>
    )
}

export default LeaveCard;